import { useEffect, useState, type ReactElement } from 'react';
import { CameraPermissionCard } from '@/app/CameraPermissionCard';
import { getCameraGate, subscribeCameraGate } from '@/camera/permissionGate';

export function CameraPermissionHost(): ReactElement | null {
  const [gate, setGate] = useState(getCameraGate);

  useEffect(() => subscribeCameraGate(() => {
    setGate(getCameraGate());
  }), []);

  if (gate.kind === 'none') {
    return null;
  }

  return (
    <div className="fixed inset-0 z-[80]">
      <CameraPermissionCard
        mode={gate.kind}
        onGotIt={gate.onGotIt}
        onRetry={gate.onRetry}
      />
    </div>
  );
}
